import React, { Component } from "react";
import MCard from "components/Shared/MCard.tsx";
import Grid from "@mui/material/Grid";

class SearchInstructions extends Component {
  render() {
    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <MCard
            title="Looking for something? Try typing your query into the search bar on the left"
            cellWidth={12}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <MCard
            title="Items to Search For"
            cellWidth={6}
            fields={[
              { label: "Supported Fields", value: "Examples" },
              { label: "Control Number", value: "12575866" },
              { label: "Policy or Loan Number", value: "1218080761" },
              { label: "Property or Mailing Address", value: "63 main st tonawanda ny 14150" },
              { label: "Policyholder or Borrower Name", value: "john doe" },
              { label: "Home or Work Phone", value: "8008758339 (not 800-875-8339!)" },
              { label: "Tracking Number", value: "1218156750" },
              { label: "Customer Number", value: "1547" },
              { label: "Customer, Company, or Lender Name", value: "abc insurance company" },
              { label: "Field Rep Number", value: "6134" },
              { label: "Field Rep Name", value: "seymour holmes" },
              { label: "Field Rep Email", value: "seymour.holmes@muellerreports.com" },
              { label: "Appraiser Number", value: "131" },
              { label: "Appraiser Name", value: "val hewitt wright" },
            ]}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <MCard
            title="How to Limit the Search"
            cellWidth={6}
            fields={[
              { label: "Prefix: Targeted Field", value: "Example" },
              { label: "CN: Control Number", value: "CN:12575866" },
              { label: "PN: Policy or Loan Number", value: "PN:1218080761" },
              { label: "STA: State of Property or Mailing Address", value: "STA:NY" },
              { label: "ZIP: Zip Code of Property or Mailing Address", value: "ZIP:14150" },
              { label: "TRA: Tracking Number", value: "TRA:3263827" },
              { label: "CUS: Customer Number", value: "CUS:1138" },
              { label: "FR: Field Rep Number", value: "FR:2119" },
              { label: "AN: Appraiser Number", value: "AN:117" },
              { label: "LC: LC360 Inspection Number", value: "LC:12345" },
            ]}
          />
        </Grid>
        <Grid size={12}>
          <MCard
            singleColumn
            title="Additional Tips and Tricks"
            cellWidth={12}
            fields={[
              { label: "Search for an Exact Match", value: "Put a phrase in quotes. For example: \"west seneca\"" },
              { label: "Exclude terms from your search", value: "Put - in front of a term you want to leave out. For example: STA:NY -buffalo" },
              { label: "Combine searches", value: "Put \" | \" between each search query to return results that match any one of them. For example: minneapolis | \"st paul\"" },
              { label: "Group search operations", value: "Use parenthesis to create nested searches and control the order of search operations. For example: (AN:131 | AN:74 | AN:16) (\"abc insurance company\" | \"xyz insurance company\")" },
            ]}
          />
        </Grid>
      </Grid>);
  }
}

export default SearchInstructions;